// Appearance control copy — the System / Light / Dark switch
// (`theme/ThemeToggle.tsx`) in the dashboard top bar and the Focus chrome.

import type { MsgSection } from "./types.js";

export const theme: MsgSection = {
  "theme.label": { en: "Appearance", de: "Darstellung" },
  "theme.system": { en: "System", de: "System" },
  "theme.light": { en: "Light", de: "Hell" },
  "theme.dark": { en: "Dark", de: "Dunkel" },
};
